<template>
    <nav class="pagination-ellipsis">
      <button :disabled="page === 1" @click="setPage(page - 1)">
        <span>&lt;</span>
      </button>
  
      <button
        v-for="n in pageNumbers"
        :key="n"
        :class="['page-btn', { active: page === n, ellipsis: n === '...' }]"
        @click="n !== '...' && setPage(n)"
        :disabled="n === '...'"
      >
        {{ n }}
      </button>
  
      <button :disabled="page === totalPages" @click="setPage(page + 1)">
        <span>&gt;</span>
      </button>
    </nav>
  </template>
  
  <script>
  export default {
    name: "PaginationEllipsis",
    props: {
      page: { type: Number, required: true },
      totalPages: { type: Number, required: true }
    },
    computed: {
      pageNumbers() {
        const pages = []
        if (this.totalPages <= 7) {
          for (let i = 1; i <= this.totalPages; i++) pages.push(i)
        } else {
          if (this.page > 3) pages.push(1)
          if (this.page > 4) pages.push('...')
          for (
            let i = Math.max(2, this.page - 1);
            i <= Math.min(this.totalPages - 1, this.page + 1);
            i++
          ) {
            pages.push(i)
          }
          if (this.page < this.totalPages - 3) pages.push('...')
          if (this.page < this.totalPages - 2) pages.push(this.totalPages)
        }
        return pages
      }
    },
    methods: {
      setPage(n) {
        if (n >= 1 && n <= this.totalPages && n !== this.page) {
          this.$emit("update:page", n)
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .pagination-ellipsis {
    display: flex;
    gap: 4px;
    align-items: center;
    background: #f8f8fa;
    border-radius: 8px;
    padding: 6px 18px;
    font-size: 17px;
  }
  .page-btn {
    border: none;
    background: none;
    color: #888;
    padding: 4px 11px;
    border-radius: 5px;
    font-size: 17px;
    min-width: 32px;
    cursor: pointer;
    transition: 0.15s;
  }
  .page-btn.active {
    background: #2196f3;
    color: #fff;
    font-weight: 600;
  }
  .page-btn.ellipsis {
    cursor: default;
    color: #bbb;
    background: transparent;
    pointer-events: none;
  }
  button[disabled] {
    opacity: 0.3;
    cursor: not-allowed;
    background: none;
  }
  </style>
  